import React, { useState } from "react";

function Tile(props) {
  const [flipped, setFlipped] = useState(false);

  const handleFlip = () => {
    setFlipped(!flipped);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleFlip();
    }
  };

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    e.currentTarget.style.setProperty("--mouse-x", `${x}px`);
    e.currentTarget.style.setProperty("--mouse-y", `${y}px`);
  };

  const handleLinkClick = (e, url) => {
    e.stopPropagation();
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className={`portfolio-tile reveal-on-scroll ${flipped ? "flipped" : ""} ${props.featured ? "featured-tile" : ""}`}
      onClick={handleFlip}
      onKeyDown={handleKeyDown}
      onMouseMove={handleMouseMove}
      role="button"
      tabIndex={0}
      aria-label={`${props.title} - Click or press enter to ${flipped ? "view overview" : "view technical highlights"}`}
    >
      <div className="tile-inner">
        {/* FRONT */}
        <div className="tile-face tile-front">
          <figure className="portfolio-img-wrap">
            <img 
              src={props.src} 
              alt={props.alt || props.title} 
              className="portfolio-img" 
              loading="lazy" 
            />
          </figure>

          <div className="tile-header-area">
            <h3 className="project-title">{props.title}</h3>
            {props.badge && <span className="project-badge">{props.badge}</span>}
          </div>

          <p className="project-brief">{props.brief}</p>

          <div className="tech-tags">
            {props.tech?.map((t) => (
              <span key={t}>{t}</span>
            ))}
          </div>

          <div className="tile-bottom-bar">
            <div className="project-links">
              {props.link && (
                <button
                  type="button"
                  className="project-action-btn live-btn"
                  onClick={(e) => handleLinkClick(e, props.link)}
                  title="View Live Demo"
                  aria-label={`Live Demo of ${props.title}`}
                >
                  <i className="fa fa-external-link" aria-hidden="true"></i>
                  <span>Live</span>
                </button>
              )}
              {props.github && (
                <button
                  type="button"
                  className="project-action-btn github-btn"
                  onClick={(e) => handleLinkClick(e, props.github)}
                  title="View GitHub Repository"
                  aria-label={`GitHub Repository of ${props.title}`}
                >
                  <i className="fa fa-github" aria-hidden="true"></i>
                  <span>Code</span>
                </button>
              )}
              {props.publication && (
                <button
                  type="button"
                  className="project-action-btn pub-btn"
                  onClick={(e) => handleLinkClick(e, props.publication)}
                  title="Read Research Publication"
                  aria-label={`Research Publication for ${props.title}`}
                >
                  <i className="fa fa-book" aria-hidden="true"></i>
                  <span>Publication</span>
                </button>
              )}
            </div>

            <span className="flip-prompt" title="Flip card for details">
              <i className="fa fa-repeat" aria-hidden="true"></i>
              <span>Details</span>
            </span>
          </div>
        </div>

        {/* BACK */}
        <div className="tile-face tile-back">
          <div className="back-header">
            <h3 className="back-title">{props.title}</h3>
            <span className="back-subtitle">Architecture & Highlights</span>
          </div>

          <ul className="details-list">
            {props.details?.map((item, index) => (
              <li key={index} className="details-item">
                <span className="bullet-point" aria-hidden="true">▹</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>

          <div className="tile-back-bottom">
            <div className="project-links">
              {props.link && (
                <button
                  type="button"
                  className="project-action-btn live-btn"
                  onClick={(e) => handleLinkClick(e, props.link)}
                  aria-label={`Live Demo of ${props.title}`}
                >
                  <i className="fa fa-external-link" aria-hidden="true"></i>
                  <span>Live</span>
                </button>
              )}
              {props.github && (
                <button
                  type="button"
                  className="project-action-btn github-btn"
                  onClick={(e) => handleLinkClick(e, props.github)}
                  aria-label={`GitHub of ${props.title}`}
                >
                  <i className="fa fa-github" aria-hidden="true"></i>
                  <span>Code</span>
                </button>
              )}
              {props.publication && (
                <button
                  type="button"
                  className="project-action-btn pub-btn"
                  onClick={(e) => handleLinkClick(e, props.publication)}
                  aria-label={`Publication for ${props.title}`}
                >
                  <i className="fa fa-book" aria-hidden="true"></i>
                  <span>Publication</span>
                </button>
              )}
            </div>
            <span className="flip-prompt">
              <i className="fa fa-repeat" aria-hidden="true"></i>
              <span>Back</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tile;
